
























import {Component} from 'vue-property-decorator'
import {Inject} from "typescript-ioc";
import CompanyBookApi, {ExportRentalLogForm} from "@/api/CompanyBookApi";
import {DatePicker} from "element-ui";
import {DateUtil} from "tools-ts/src/date/DateUtil";
import FileSaver from 'file-saver'
import BaseDialog from "@/component/Dialog/base-dialog.vue";
import moment from "moment";

@Component({})
export default class ExportRentalLogDialog extends BaseDialog {

    @Inject
    private cbookApi!: CompanyBookApi

    private form = new ExportRentalLogForm()
    private createdAtRange = [DateUtil.startOfDay(), new Date()]

    private created() {
        this.assignForm()
    }

    private handleDateChange() {
        this.assignForm()
    }

    private assignForm(range: Array<Date> = this.createdAtRange) {
        this.form.createdAtStart = range[0]
        this.form.createdAtEnd = DateUtil.endOfDay(range[1])
    }

    protected async doConfirm(): Promise<void> {
        await this.exportRentalLogs()
    }

    private async exportRentalLogs() {
        const data = await this.cbookApi.exportRentalLog(this.form)
        const start = moment(this.createdAtRange[0]).format("YYYYMMDD")
        const end = moment(this.createdAtRange[1]).format("YYYYMMDD")
        FileSaver.saveAs(data, `图书借阅日志.${start}-${end}.xlsx`)
    }

    private pickerOptions = {
        disabledDate(date: Date) {
            return date.getTime() > Date.now();
        },
        shortcuts: [
            {
                text: '本月',
                onClick(picker: DatePicker) {
                    const start = moment().startOf('month').toDate()
                    const end = new Date()
                    picker.$emit('pick', [start, end])
                }
            },
            {
                text: '上个月',
                onClick(picker: DatePicker) {
                    const start =
                        moment().startOf('month').subtract('month', 1).toDate()
                    const end = moment().endOf('month').subtract('month', 1).endOf('month').toDate()
                    picker.$emit('pick', [start, end])
                }
            },
            {
                text: '近一周',
                onClick(picker: DatePicker) {
                    const start = new Date()
                    const end = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                    picker.$emit('pick', [start, end])
                }
            }, {
                text: '近一个月',
                onClick(picker: DatePicker) {
                    const start = new Date()
                    const end = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                    picker.$emit('pick', [start, end])
                }
            }, {
                text: '近三个月',
                onClick(picker: DatePicker) {
                    const start = new Date()
                    const end = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                    picker.$emit('pick', [start, end])
                }
            }, {
                text: '近一年',
                onClick(picker: DatePicker) {
                    const start = new Date()
                    const end = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
                    picker.$emit('pick', [start, end])
                }
            }
        ]
    }
}
